var generateComponentTheme = function generateComponentTheme(_ref) {
  var colors = _ref.colors,
    spacing = _ref.spacing,
    borders = _ref.borders;
  return {
    errorBorderMargin: spacing.xxSmall,
    errorBorderPadding: spacing.xxSmall,
    errorBorderColor: colors.crimson,
    errorBorderRadius: borders.radiusSmall
  };
};
export default generateComponentTheme;